import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 252体力锁
 */

export default class EventStoryLock extends EventBase {
  constructor() {
    super()
    this.Parameter = ['0', '']
  }

  get CommodityId() {
    return parseInt(this.Parameter?.[0] ?? '')
  }
  set CommodityId(value) {
    this.Parameter && (this.Parameter[0] = value.toString())
  }

  /**
   * 获得该事件在事件列表的描述信息
   */
  /// <returns>事件描述信息</returns>
  get Description() {
    return this.Parameter?.[1] ?? ''
  }
  set Description(value) {
    this.Parameter && (this.Parameter[1] = value.toString())
  }

  Code = EventID.StoryLock
  public GetParameter() {
    return this.Parameter
  }
}
